import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { toast } from 'sonner';
import { Calendar, Clock, Users, CheckCircle2 } from 'lucide-react';
// Generate time slots from 09:00 to 22:00 in 30 min increments
const generateTimeSlots = () => {
  const slots = [];
  for (let h = 9; h <= 21; h++) {
    slots.push(`${h.toString().padStart(2, '0')}:00`);
    slots.push(`${h.toString().padStart(2, '0')}:30`);
  }
  slots.push('22:00');
  return slots;
};
const TIME_SLOTS = generateTimeSlots();
export function ReservationForm() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    telefono: '',
    fecha: '',
    hora: '',
    personas: '2',
    peticiones: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate API call
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSuccess(true);
      toast.success('Reserva confirmada con éxito');
    }, 1500);
  };
  if (isSuccess) {
    return <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} className="bg-white p-8 md:p-12 rounded-2xl shadow-soft text-center border border-cafe-border/50 max-w-2xl mx-auto" data-id="element-167">
        <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-168">
          <CheckCircle2 className="text-green-500 w-10 h-10" data-id="element-169" />
        </div>
        <h3 className="text-3xl font-serif text-cafe-primary mb-4" data-id="element-170">
          ¡Reserva Confirmada!
        </h3>
        <p className="text-cafe-text/80 mb-8 text-lg" data-id="element-171">
          Gracias {formData.nombre}. Te hemos enviado un email de confirmación a{' '}
          {formData.email}.
        </p>
        <div className="bg-cafe-bg rounded-xl p-6 text-left max-w-sm mx-auto mb-8 space-y-3" data-id="element-172">
          <div className="flex items-center text-cafe-text/80" data-id="element-173">
            <Calendar className="w-5 h-5 mr-3 text-cafe-accent" data-id="element-174" />
            <span data-id="element-175">{formData.fecha}</span>
          </div>
          <div className="flex items-center text-cafe-text/80" data-id="element-176">
            <Clock className="w-5 h-5 mr-3 text-cafe-accent" data-id="element-177" />
            <span data-id="element-178">{formData.hora}</span>
          </div>
          <div className="flex items-center text-cafe-text/80" data-id="element-179">
            <Users className="w-5 h-5 mr-3 text-cafe-accent" data-id="element-180" />
            <span data-id="element-181">
              {formData.personas}{' '}
              {parseInt(formData.personas) === 1 ? 'persona' : 'personas'}
            </span>
          </div>
        </div>
        <button onClick={() => {
        setIsSuccess(false);
        setFormData({
          nombre: '',
          apellidos: '',
          email: '',
          telefono: '',
          fecha: '',
          hora: '',
          personas: '2',
          peticiones: ''
        });
      }} className="text-cafe-accent hover:text-cafe-primary font-medium transition-colors underline underline-offset-4" data-id="element-182">
          Hacer otra reserva
        </button>
      </motion.div>;
  }
  return <motion.form initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} onSubmit={handleSubmit} className="bg-white p-6 md:p-10 rounded-2xl shadow-soft border border-cafe-border/50 max-w-3xl mx-auto" data-id="element-183">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-184">
        {/* Personal Info */}
        <div className="space-y-2" data-id="element-185">
          <label htmlFor="nombre" className="block text-sm font-medium text-cafe-text" data-id="element-186">
            Nombre *
          </label>
          <input type="text" id="nombre" name="nombre" required value={formData.nombre} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors" data-id="element-187" />
        </div>
        <div className="space-y-2" data-id="element-188">
          <label htmlFor="apellidos" className="block text-sm font-medium text-cafe-text" data-id="element-189">
            Apellidos *
          </label>
          <input type="text" id="apellidos" name="apellidos" required value={formData.apellidos} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors" data-id="element-190" />
        </div>
        <div className="space-y-2" data-id="element-191">
          <label htmlFor="email" className="block text-sm font-medium text-cafe-text" data-id="element-192">
            Email *
          </label>
          <input type="email" id="email" name="email" required value={formData.email} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors" data-id="element-193" />
        </div>
        <div className="space-y-2" data-id="element-194">
          <label htmlFor="telefono" className="block text-sm font-medium text-cafe-text" data-id="element-195">
            Teléfono *
          </label>
          <input type="tel" id="telefono" name="telefono" required value={formData.telefono} onChange={handleChange} className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors" data-id="element-196" />
        </div>
        {/* Reservation Details */}
        <div className="space-y-2" data-id="element-197">
          <label htmlFor="fecha" className="block text-sm font-medium text-cafe-text" data-id="element-198">
            Fecha *
          </label>
          <div className="relative" data-id="element-199">
            <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 text-cafe-text/50 w-5 h-5 pointer-events-none" data-id="element-200" />
            <input type="date" id="fecha" name="fecha" required min={new Date().toISOString().split('T')[0]} value={formData.fecha} onChange={handleChange} className="w-full pl-10 pr-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors appearance-none" data-id="element-201" />
          </div>
        </div>
        <div className="space-y-2" data-id="element-202">
          <label htmlFor="hora" className="block text-sm font-medium text-cafe-text" data-id="element-203">
            Hora *
          </label>
          <div className="relative" data-id="element-204">
            <Clock className="absolute left-3 top-1/2 -translate-y-1/2 text-cafe-text/50 w-5 h-5 pointer-events-none" data-id="element-205" />
            <select id="hora" name="hora" required value={formData.hora} onChange={handleChange} className="w-full pl-10 pr-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors appearance-none" data-id="element-206">
              <option value="" disabled data-id="element-207">
                Seleccionar hora
              </option>
              {TIME_SLOTS.map(slot => <option key={slot} value={slot} data-id="element-208">
                  {slot}
                </option>)}
            </select>
          </div>
        </div>
        <div className="space-y-2 md:col-span-2" data-id="element-209">
          <label htmlFor="personas" className="block text-sm font-medium text-cafe-text" data-id="element-210">
            Número de personas *
          </label>
          <div className="relative" data-id="element-211">
            <Users className="absolute left-3 top-1/2 -translate-y-1/2 text-cafe-text/50 w-5 h-5 pointer-events-none" data-id="element-212" />
            <select id="personas" name="personas" required value={formData.personas} onChange={handleChange} className="w-full pl-10 pr-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors appearance-none" data-id="element-213">
              {[...Array(10)].map((_, i) => <option key={i + 1} value={i + 1} data-id="element-214">
                  {i + 1} {i === 0 ? 'persona' : 'personas'}
                </option>)}
            </select>
          </div>
        </div>
        {/* Special Requests */}
        <div className="space-y-2 md:col-span-2" data-id="element-215">
          <label htmlFor="peticiones" className="block text-sm font-medium text-cafe-text" data-id="element-216">
            Peticiones especiales (Opcional)
          </label>
          <textarea id="peticiones" name="peticiones" rows={3} value={formData.peticiones} onChange={handleChange} placeholder="Alergias, trona para bebé, preferencia de mesa..." className="w-full px-4 py-3 rounded-lg bg-cafe-bg border border-cafe-border focus:border-cafe-accent focus:ring-1 focus:ring-cafe-accent outline-none transition-colors resize-none" data-id="element-217" />
        </div>
      </div>
      <button type="submit" disabled={isSubmitting} className="w-full bg-cafe-primary text-white py-4 rounded-xl font-medium text-lg hover:bg-cafe-accent transition-colors disabled:opacity-70 disabled:cursor-not-allowed flex justify-center items-center" data-id="element-218">
        {isSubmitting ? <span className="flex items-center" data-id="element-219">
            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" data-id="element-220">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" data-id="element-221"></circle>
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" data-id="element-222"></path>
            </svg>
            Procesando...
          </span> : 'Confirmar Reserva'}
      </button>
    </motion.form>;
}